module.exports = __webpack_public_path__ + "static/media/community-background.36cdd069.svg";